import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Form,
  Container,
  Button,
  FormGroup,
  Alert,
  Image,
} from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { isEmpty, isNumber } from "lodash";
import Spinner from "react-bootstrap/Spinner";
import MaterialSize from "material-table";
import "jspdf-autotable";
import Swal from "sweetalert";
import { setHeading } from "../../../accounts/account.actions";
import { addUom } from "./Uom.action";
const AddUom = (props) => {
  const [uomName, setUomName] = useState("");
  const [uomUnit, setUomUnit] = useState("");
  const [uomDesc, setUomDesc] = useState("");

  const [visibleAlert, setAlertVisible] = useState(false);
  const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);


  const handleVisible = (msg) => {
    setAlertVisible(true);
    setTimeout(() => {
      setAlertVisible(false);
    }, 9000);
    Swal({
      title: "Success",
      text: msg,
      icon: "success",
      button: "Ok",
    });
  };

  const handleDangerVisible = (err) => {
    setDangerVisibleAlert(true);
    setTimeout(() => {
      setDangerVisibleAlert(false);
    }, 9000);
    Swal({
      title: "Error",
      text: err,
      icon: "error",
      button: "Ok",
    });
  };

  function uploadUom() {
    props.addUom(
      {
        unitName: uomName,
        unitCode:uomUnit,
        desc: uomDesc,
      },
      handleVisible,
      handleDangerVisible
    );
    setUomDesc("");
    setUomUnit("");
    setUomName("");
  }

 
  useEffect(() => {
    props.setHeading("Add Uom");
;
  }, []);
  return (
    <>
      {props.isAddingUom ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main">
            <div>
              <Form>

                <Row>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Uom Name *</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Uom Name...."
                        onChange={(e) => setUomName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Uom Unit *</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Uom Unit...."
                        onChange={(e) => setUomUnit(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                 
                </Row>
                <Row>
                <Col lg="6" md="6" xs="6">
                    <Form.Group className="mb-3" controlId="garana">
                      <Form.Label>
                        <b>Uom Description :</b>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        // value={hallDesc}
                        placeholder="Uom Description...."
                        onChange={(e) => setUomDesc(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="sendDiv">
                  {isEmpty(uomName) || isEmpty(uomUnit) ? (
                    <Button
                      disabled
                      style={{
                        marginLeft: "2%",
                        color: "white",
                        width: "20%",
                        backgroundColor: "#1976d2",
                        border: "1px solid #1976d2",
                      }}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button onClick={uploadUom}>Save</Button>
                  )}
                </div>
              </Form>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {

    setHeading: (data) => dispatch(setHeading(data)),
    addUom:(data,handleVisible,handleDangerVisible)=>dispatch(addUom(data,handleVisible,handleDangerVisible)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingUom:state.uomReducer.isAddingUom
});

export default connect(mapStateToProps, mapDispatchToProps)(AddUom);
